import { Card } from "@/components/ui/card";

interface DocFormulaProps {
  children: React.ReactNode;
}

export function DocFormula({ children }: DocFormulaProps) {
  return (
    <Card className="my-5 overflow-x-auto border border-border bg-card p-4 text-center font-mono text-sm text-foreground shadow-sm">
      {children}
    </Card>
  );
}
